import { AssetType, BodyType, Category, FuelType, Gear } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredPastDate, requiredString } from '@/utils/zodUtils';

export const AutoDetailsFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      type: requiredEnum(AssetType, t),
      description: z.string().nullable(),
      amount: requiredString(t),
      brand: requiredString(t),
      model: requiredString(t),
      version: requiredString(t),
      licensePlateNumber: z.string().nullable(),
      identificationNumber: z.string().nullable(),
      registrationDate: requiredPastDate(t).nullable(),
      odometer: z.string().nullable(),
      power: z.string().nullable(),
      engine: z.string().nullable(),
      fuelType: requiredEnum(FuelType, t).nullable(),
      category: requiredEnum(Category, t),
      bodyType: requiredEnum(BodyType, t).nullable(),
      gearType: requiredEnum(Gear, t).nullable(),
      isNewVehicle: z.boolean(),
      imported: z.boolean().nullable(),
    })
    .strict();

export type AutoDetailsFormType = z.infer<ReturnType<typeof AutoDetailsFormSchema>>;
